import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { Container, CssBaseline, Stack, Typography } from '@mui/material';

import { notScrollable, flexColFullHeightScrollable, p1 } from '../common/ui/sx/common';

import { usePageLayoutConfigurator } from '../common/hooks/usePageLayoutConfigurator';
import PageNames from '../common/utils/PageNames';
import PrimaryButton from '../common/ui/qvshop/components/core/PrimaryButton';
import TextField from '../common/ui/qvshop/components/TextField';

import {
    resendRegistrationVerification,
    selectRegisteredEmail,
    selectResendVerificationLoading,
    selectResendVerificationSucceeded,
    setRegisterStatusIdle
} from '../common/store/registerSlice';

export default function RegisterFinished() {
    usePageLayoutConfigurator(PageNames.REGISTER_FINISHED);
    const { t } = useTranslation(['common', 'registerFinished']);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const registeredEmail = useSelector(selectRegisteredEmail);
    const resendLoading = useSelector(selectResendVerificationLoading);
    const resendSucceeded = useSelector(selectResendVerificationSucceeded);
    const [email, setEmail] = useState(registeredEmail);

    const handleRegisterFinishedAcknoledged = () => {
        // Set the make reservation status back to idle
        dispatch(setRegisterStatusIdle());
        navigate("/login");
    }

    const handleResendVerification = () => {
        dispatch(resendRegistrationVerification(email.trim()));
    };

    return (
        <Container sx={{...flexColFullHeightScrollable, ...notScrollable, ...p1}} component="main" maxWidth="sm" >
            <CssBaseline />
            <Stack sx={{ minHeight: '100vh' }} direction="column" spacing={3} alignItems="center" justifyContent="center">
                <Typography variant="h5">{t("registerFinished:title")}</Typography>
                <Stack direction="column" spacing={2} alignItems="center">
                    <Stack direction="column" spacing={0} alignItems="center">
                        <Typography align="center" variant="body1">{t("registerFinished:text1")}</Typography>
                        <Typography align="center" variant="body1">{t("registerFinished:text2")}</Typography>
                        <Typography align="center" variant="body1">{t("registerFinished:text3")}</Typography>
                    </Stack>
                    {resendSucceeded &&
                        <Typography align="center" color="success.main" variant="body2">
                            {t("registerFinished:resendSuccess")}
                        </Typography>
                    }
                    <TextField
                        fullWidth
                        id="email"
                        label={t("registerFinished:emailLabel")}
                        name="email"
                        type="email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                    />
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <PrimaryButton
                            disabled={email.trim() === '' || resendLoading}
                            label={t("registerFinished:button.resend")}
                            onClick={handleResendVerification}
                        />
                        <PrimaryButton label={t("registerFinished:button.toLogin")} onClick={handleRegisterFinishedAcknoledged} />
                    </Stack>
                </Stack>
            </Stack>
        </Container>
    );
};
